import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Stringable, StringableValues } from '../../../../../../common/stringable.decorator'
import {  StateService, VisiteService } from '../../../../../../services'
import * as moment from 'moment'
import { ActivatedRoute } from '@angular/router'

import { PageRoute } from '../../../../../../Interfaces/PageRoute'
import { JSONRpcResponse } from '../../../../../../Interfaces/JSONRpcResponse'
import { BehaviorSubject } from 'rxjs'

const KEY = 'visite-list'

@Component({
  selector: 'atyl-visite-list-partials',
  templateUrl: './visite-list.component.html',
  styleUrls: ['./visite-list.component.scss'],
})
@Stringable({
  path: 'views/pages/consultation/visites/list',
  key: KEY,
})
export class VisiteListComponent implements OnInit {
  @Input() consultation: any
  @Output() selected:any = new EventEmitter<any>();
  @StringableValues(KEY) strings: any
  componentVisites: any[] = [];
  loading: boolean = true;

  etatList:any[]=[];
  visiteToOpen: BehaviorSubject<number> = new BehaviorSubject<number>(0)
  vs:any={};
  
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private stateService: StateService,
    private activatedRoute: ActivatedRoute,
	 private visiteService:VisiteService,

  ) { }

  ngOnInit() {
    this.activatedRoute.queryParamMap.subscribe(params => {
      var visiteId = null
      const paramVisite = params.get('visite');
      if(paramVisite != undefined){
        visiteId = parseInt(paramVisite);
        this.visiteToOpen.next(visiteId);
      }
    });
    
    this._getEtatList();

	let rt:PageRoute= this.stateService.getCurrentRoute();  
    if (this.consultation.visitesObj) {
      this.loading = false
    }
   
    this.loadHeader()
    this.changeDetectorRef.detectChanges()
    
    if (!rt || (rt.checkRoute(this.activatedRoute))) {
				let route:PageRoute =new PageRoute();
				route.label="Visite";
				
				
				route.setUrl(this.activatedRoute);
				
				
				this.stateService.setRoute(route);
	}
    
  }

  ngOnChanges() {
    if (this.consultation.visitesObj) {
      this.loading = false
      for(let i=0;i<this.consultation.visitesObj.length;i++) {
				let v:any=this.consultation.visitesObj[i];
			  this.vs[v.ID+""]=v;
			}
      this._createdSelected();
    }
    
     this.loadHeader()
    this.changeDetectorRef.detectChanges()
  }
  
  loadHeader() {
       if (this.consultation!=undefined && this.consultation && this.consultation.visitesObj ) {
            let subHeader =  "<h4>"
            console.log("consultation header",this.consultation);
            if (this.consultation.type!=undefined && this.consultation.type) 
                subHeader+=this.consultation.type.libelle;
                
             if (this.consultation.domicile!=undefined && this.consultation.domicile)  
                subHeader+= '&nbsp;<span class="subheader_bagde subheader_bagde_domicile">D</span>';
                
             if (this.consultation.ponctuel!=undefined && this.consultation.ponctuel)  
                subHeader+= '&nbsp;<span class="subheader_bagde subheader_bagde_ponctuel">P</span>';     
                
            if (this.consultation.lieu!=undefined && this.consultation.lieu) 
                subHeader+=" à "+ this.consultation.lieu.NOM;
			subHeader+="</h4>" 
			        
            let begin=false;

            if (this.consultation.date_debut!=undefined && this.consultation.date_debut) {
                subHeader+="<br/> Du " + moment(this.consultation.date_debut).format('DD/MM/YYYY HH:mm');                   
                begin=true; 
            }
           
            if (this.consultation.date_fin!=undefined && this.consultation.date_fin) {
               
                subHeader+=(begin) ?" au ": "<br/> le ";
                 
                subHeader+= moment(this.consultation.date_fin).format('DD/MM/YYYY HH:mm');                     
                
            }
            if (this.consultation.professionels!=undefined 
            && this.consultation.professionels
             && this.consultation.professionels.length>0) {
                var prfs=[];
                for(let i=0;i<this.consultation.professionels.length;i++) {
                    let prf=this.consultation.professionels[i].NOM+" "+this.consultation.professionels[i].PRENOM
                    prfs.push(prf);
                }
                 subHeader+="<br/>"+prfs.join(" , ");
                
            }
            
            console.log("VisiteListComponent liste subHeader",subHeader);
            this.stateService.updateSubHeader(subHeader);
        }
    
  }  
  
  visiteClosed(event:any) {
	  console.log("VisiteListComponent close",event,this.consultation)
	  
	  this.loadHeader();
	/*   this.changeDetectorRef.detectChanges()
	   this.stateService.updateConsultation(this.consultation);*/
  } 

  _getEtatList() {
  			this.etatList=[];
  			this.visiteService.getVisiteEtats().subscribe((res: JSONRpcResponse) => {
  				if (res.result) {
  					this.etatList=res.result;
  				}
  				
  			})
  			
  	}

    visiteOpened(event:Event){
      this.visiteToOpen.next(null);
      this.visiteToOpen.complete();
    }

    _createdSelected(selectedID:any=null,elt:any=null) {
      if (elt!=null && selectedID==null) {
        this.vs[elt.ID+""]=undefined;
      }	
      if (elt!=null && selectedID!=null) {
        this.vs[elt.ID+""]=elt;
      }
      let vss:any[]=[];
      Object.keys(this.vs).forEach((IDD:any)=>{
        if (this.vs[IDD]!=undefined)
          vss.push(this.vs[IDD]);
      })	
      this.selected.emit(vss);
    }

    selectedVist(event:any,elt:any) {
      console.log("VisiteListComponent semlected",event,elt)
      this._createdSelected(event,elt)
    }

}
